import type { ObjectId } from '@freightview/object-id'

import type { DTO } from '../core/dto.ts'
import {
  vArray,
  vEmail,
  vNonEmptyString,
  vObject,
  vOmit,
  vOptional,
  type vOutput,
  vPartial,
  vString,
  vWorkflow,
} from '../validation/index.ts'
import { baseLoadBillToSchema } from './load.ts'
import { loadEquipmentSchema } from './load-equipment.ts'
import { loadHandlingUnitSchema } from './load-handling-unit.ts'
import { loadLocationSchema } from './load-location.ts'
import { locationAccessorialSchema } from './location-accessorial.ts'

export interface LoadTemplate extends Omit<UpsertLoadTemplateDTO, 'brandId'> {
  _id: ObjectId
  accountId: ObjectId
  brandId?: ObjectId
  createdByUserId: ObjectId
  createdDate: Date
  removedDate?: Date
}

export const templateLocationSchema = vObject({
  ...vOmit(vPartial(loadLocationSchema), [
    'refNums',
    'stopDate',
    'accessorials',
  ]).entries,
  accessorials: vOptional(vArray(locationAccessorialSchema)),
  shares: vOptional(vArray(vEmail)),
})

export type TemplateLocation = vOutput<typeof templateLocationSchema>

export const templateEquipmentSchema = vPartial(
  vOmit(loadEquipmentSchema, ['mode']),
)
export type TemplateEquipment = vOutput<typeof templateEquipmentSchema>

export const templateHandlingUnitSchema = vPartial(
  vOmit(loadHandlingUnitSchema, [
    'refNums',
    'pickupLocationSequence',
    'dropLocationSequence',
  ]),
)
export type TemplateHandlingUnit = vOutput<typeof templateHandlingUnitSchema>

export type LoadTemplateDTO = DTO<LoadTemplate>

export const upsertLoadTemplateSchema = vObject({
  name: vNonEmptyString(),
  workflow: vWorkflow(),
  brandId: vOptional(vString()),
  origin: vOptional(templateLocationSchema),
  destination: vOptional(templateLocationSchema),
  billTo: vOptional(vPartial(baseLoadBillToSchema)),
  equipment: vOptional(templateEquipmentSchema),
  items: vOptional(vArray(templateHandlingUnitSchema)),
  glCode: vOptional(vString()),
  tags: vOptional(vArray(vString())),
})

export type UpsertLoadTemplateDTO = vOutput<typeof upsertLoadTemplateSchema>
